import { createContext } from 'react';

const MessagerManagerContext = createContext();

export default MessagerManagerContext;
